/* Tattup delivery dates – the ONE calculator (replaces the ETA app). Config: window.TTETA_CFG, printed by
   snippets/tt-eta.liquid from the shop metafield tattup.delivery (dashboard tab «Lieferzeiten» in tattup-own-apps).

   Rule: an order placed before the cutoff (12:00 Europe/Zurich) on a dispatch day leaves the warehouse today, otherwise
   on the next dispatch day (Sunday never, warehouse holidays + company days skipped). Delivery = dispatch day + min / max
   delivery days of the destination (Sunday never, the country's holidays skipped).

   What it does:
   - PDP ticket ([data-tt-eta]): «Lieferung bis 22.10.» + «bei Bestellung in den nächsten 18 Std 28 Min» (ticks per minute)
   - cart drawer / cart page ([data-tt-eta-cart]): «Lieferung zwischen 22/10/2026 und 23/10/2026»
   - line item property «Lieferung bis» / «Order Estimation» = «22.10.26 - 23.10.26» (DE) / «22/10/2026 - 23/10/2026» (EN)
     on every shipped normal line (date format per language from the dashboard);
     Shopify carries it into the checkout, the order and the emails. With a custom tattoo in the cart NO normal line
     carries it (the custom line keeps the Studio's «Lieferzeit», Ship Right renames the shipping method).
     Written into every add-to-cart request (fetch body) and corrected with /cart/change.js (all other properties kept,
     same quantity + selling plan) on page view (only if the printed cart differs), after every cart change, when the
     drawer opens, when the tab comes back with a new date and right before the checkout (click / submit is held,
     max. 4 s). Only lines whose value really differs are written, one request at a time.
   Switched off in the dashboard (C.off): nothing is shown or written, only an existing delivery property is removed.
   Test: ?tt_eta_now=2026-10-23T12:30 (Zurich time; kept for this tab, ?tt_eta_now=off ends it) – calculation only. */
(function () {
  'use strict';
  var C = window.TTETA_CFG;
  if (!C || window.TTEta) return;
  var DAY = 864e5;
  var T = C.t || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var NAMES = {};
  (C.names || []).forEach(function (n) { NAMES[n] = 1; });
  var PROP = T.prop || 'Lieferung bis';
  NAMES[PROP] = 1;
  function set(list) { var o = {}; (list || []).forEach(function (d) { o[d] = 1; }); return o; }
  var WH = set(C.w), HOL = set(C.h);
  var SD = C.sd || [1, 2, 3, 4, 5, 6], DD = C.dd || [1, 2, 3, 4, 5, 6];
  var cut = String(C.cut || '12:00').split(':'), CUT_H = +cut[0] || 0, CUT_M = +cut[1] || 0;
  var CP = {};
  (C.cp || []).forEach(function (id) { CP[id] = 1; });

  /* ---------- time in Europe/Zurich ---------- */
  var dtf = null;
  function parts(ms) {
    try {
      dtf = dtf || new Intl.DateTimeFormat('en-GB', { timeZone: C.tz || 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      var o = {};
      dtf.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute };
    } catch (e) {
      var d = new Date(ms);
      return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate(), h: d.getHours(), mi: d.getMinutes() };
    }
  }
  /* epoch ms of a wall-clock time in the shop time zone (DST-safe) */
  function epoch(y, m, d, h, mi) {
    var wall = Date.UTC(y, m - 1, d, h, mi), g = wall;
    for (var i = 0; i < 3; i++) { var p = parts(g); g = wall - (Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi) - g); }
    return g;
  }
  var shift = 0;
  try {
    var q = /[?&]tt_eta_now=([^&#]+)/.exec(location.search);
    if (q) { q = decodeURIComponent(q[1]); if (q === 'off') sessionStorage.removeItem('tt_eta_now'); else sessionStorage.setItem('tt_eta_now', q); }
    var tm = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(sessionStorage.getItem('tt_eta_now') || '');
    if (tm) shift = epoch(+tm[1], +tm[2], +tm[3], +tm[4], +tm[5]) - Date.now();
  } catch (e) { /* storage blocked */ }
  function now() { return Date.now() + shift; }

  /* ---------- calendar days (day numbers since 1970, UTC based) ---------- */
  function iso(dn) { return new Date(dn * DAY).toISOString().slice(0, 10); }
  function wd(dn) { return new Date(dn * DAY).getUTCDay(); }
  function shipDay(dn) { return SD.indexOf(wd(dn)) > -1 && !WH[iso(dn)]; }
  function delDay(dn) { return DD.indexOf(wd(dn)) > -1 && !HOL[iso(dn)]; }
  function addDel(dn, n) { for (var k = 0, g = 0; k < n && g < 200; g++) { dn++; if (delDay(dn)) k++; } return dn; }

  /* { ship, from, to } as day numbers + until = ms when the result changes (cutoff of the dispatch day) */
  function calc(ms) {
    var p = parts(ms), dn = Date.UTC(p.y, p.m - 1, p.d) / DAY, g = 0;
    if (!shipDay(dn) || p.h * 60 + p.mi >= CUT_H * 60 + CUT_M) { do { dn++; } while (!shipDay(dn) && ++g < 60); }
    var s = new Date(dn * DAY);
    return { ship: dn, from: addDel(dn, +C.min || 0), to: addDel(dn, +C.max || 0), until: epoch(s.getUTCFullYear(), s.getUTCMonth() + 1, s.getUTCDate(), CUT_H, CUT_M) };
  }
  function fmtDay(dn) {
    var d = new Date(dn * DAY), dd = ('0' + d.getUTCDate()).slice(-2), mm = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    var y = String(d.getUTCFullYear());
    /* format of the shop language (dashboard: DE «DD.MM.YY», EN «DD/MM/YYYY»), tokens DD MM YYYY YY */
    return String(T.fmt || C.fmt || 'DD/MM/YYYY').replace(/YYYY|YY|MM|DD/g, function (t) { return t === 'YYYY' ? y : t === 'YY' ? y.slice(2) : t === 'MM' ? mm : dd; });
  }
  function value(r) { r = r || calc(now()); return fmtDay(r.from) + (C.sep == null ? ' - ' : C.sep) + fmtDay(r.to); }

  /* ---------- which property a line must carry ---------- */
  var customKey = {};
  (C.cart || []).forEach(function (l) { if (l[1]) { customKey[l[0]] = 1; if (l[4]) CP[l[4]] = 1; } });
  function isCustom(it) {
    var p = it.properties || {};
    return !!(customKey[it.key] || CP[it.product_id] || p._cz_design_id || p._cz_source);
  }
  var hasCustom = (C.cart || []).some(function (l) { return l[1] === 1; });
  /* our delivery properties with a value (null / "" = not shown in checkout and emails, counts as none) */
  function managed(p) { var o = {}, n = 0; for (var k in p) if (NAMES[k] && p[k] != null && p[k] !== '') { o[k] = p[k]; n++; } return n ? o : null; }
  /* null = line is fine, else the complete new properties object */
  function planLine(it, val) {
    var p = it.properties || {}, cur = managed(p);
    var want = val && it.requires_shipping !== false && !isCustom(it) ? val : null;
    var ok = want ? (cur && Object.keys(cur).length === 1 && cur[PROP] === want) : !cur;
    if (ok) return null;
    var out = {}, n = 0;
    for (var k in p) if (!NAMES[k] && p[k] != null) { out[k] = p[k]; n++; }
    if (want) out[PROP] = want;
    /* Shopify ignores an empty properties object: blank our keys instead (hidden in checkout + emails) */
    else if (!n) for (var k2 in p) if (NAMES[k2]) out[k2] = null;
    return out;
  }
  function plan(items) {
    var custom = items.some(isCustom), val = custom || C.off ? null : value();
    for (var i = 0; i < items.length; i++) { var np = planLine(items[i], val); if (np) return { i: i, props: np }; }
    return null;
  }

  /* ---------- cart requests (own requests bypass the fetch hook) ---------- */
  var rawFetch = window.fetch.bind(window);
  function cartJs() { return rawFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }); }
  function change(it, props) {
    var body = { id: it.key, quantity: it.quantity, properties: props };
    if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) body.selling_plan = it.selling_plan_allocation.selling_plan.id;
    return rawFetch(ROOT + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); });
  }

  var running = null, again = false, fails = 0, self = false, lastVal = value();
  function loop(cart, n) {
    hasCustom = cart.items.some(isCustom);
    var step = plan(cart.items);
    if (!step || n > cart.items.length + 2 || fails > 3) return n;
    return change(cart.items[step.i], step.props).then(function (c) { return loop(c, n + 1); }, function () {
      fails++;
      return cartJs().then(function (c) { return loop(c, n + 1); });
    });
  }
  /* brings every line in line with the rules; resolves when done (never rejects) */
  function sync() {
    if (running) { again = true; return running; }
    lastVal = value();
    running = cartJs().then(function (c) { return loop(c, 0); }).catch(function () { return 0; }).then(function (n) {
      running = null;
      if (n) { self = true; try { document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true })); } finally { self = false; } }
      render();
      if (again) { again = false; return sync(); }
      return n;
    });
    return running;
  }
  var timer = null;
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(sync, ms || 700); }

  /* ---------- every add-to-cart request carries the date; every cart change is re-checked ---------- */
  var CART_RE = /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/;
  function inject(init) {
    if (hasCustom || C.off) return init;
    var val = value(), b = init.body;
    try {
      if (typeof b === 'string' && b.charAt(0) === '{') {
        var j = JSON.parse(b), items = j.items || (j.id ? [j] : null);
        if (!items) return init;
        items.forEach(function (it) {
          var p = it.properties || {};
          if (it.selling_plan || p._cz_design_id || p._cz_source || managed(p)) return;   // subscriptions = digital credits
          p[PROP] = val; it.properties = p;
        });
        var o = {}; for (var k in init) o[k] = init[k];
        o.body = JSON.stringify(j);
        return o;
      }
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        if (!b.has('selling_plan') && !b.has('properties[_cz_design_id]') && !b.has('properties[' + PROP + ']')) b.set('properties[' + PROP + ']', val);
      }
    } catch (e) { /* leave the request as it is – the sync after it fixes the line */ }
    return init;
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var m = method === 'POST' && CART_RE.exec(url);
    if (!m) return rawFetch(input, init);
    if (m[1] === 'add' && init && init.body) init = inject(init);
    if (m[1] === 'update' && init && typeof init.body === 'string' && init.body.indexOf('"updates"') < 0) return rawFetch(input, init); // attributes only
    var pr = rawFetch(input, init);
    pr.then(function (r) { if (r && r.ok) schedule(); }, function () {});
    return pr;
  };

  /* ---------- display ---------- */
  function dur(ms) {
    var de = C.lang === 'de', min = Math.max(1, Math.ceil(ms / 60000)), d = Math.floor(min / 1440), h = Math.floor((min % 1440) / 60), mi = min % 60;
    var out = [];
    if (d) out.push(d + (de ? (d === 1 ? ' Tag' : ' Tagen') : (d === 1 ? ' day' : ' days')));
    if (h) out.push(h + (de ? ' Std' : (h === 1 ? ' hr' : ' hrs')));
    if (!d && (mi || !h)) out.push(mi + (de ? ' Min' : (mi === 1 ? ' min' : ' mins')));
    return out.join(' ');
  }
  /* «22.10.» / «22 Oct» (no break inside); wd = with the weekday: «Do 22.10.» / «Thu 22 Oct» */
  function shortDate(dn, wd) {
    var d = new Date(dn * DAY), de = C.lang === 'de';
    var day = de ? d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.' : d.getUTCDate() + '\u00a0' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getUTCMonth()];
    if (!wd) return day;
    return (de ? ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'] : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'])[d.getUTCDay()] + '\u00a0' + day;
  }
  function dt(x) { return '<span class="tt-eta__dt">' + x + '</span>'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderPdp(r, t) {
    var sub = document.querySelector('[data-tt-eta]');
    if (!sub) return;
    var html;
    if (sub.getAttribute('data-custom') === '1') {   // the ticket shows THIS product's delivery time, whatever is in the cart
      html = '<span class="tt-eta__d">' + esc(T.cline || '') + '</span>';
    } else {
      /* «Lieferung zwischen 22.10. und 23.10.» (older template: «Lieferung bis DATES») */
      html = '<span class="tt-eta__d">' + (sub.getAttribute('data-dates') || '').replace('FROM', dt(shortDate(r.from))).replace('TO', dt(shortDate(r.to))).replace('DATES', dt(shortDate(r.to))) + '</span>' +
        '<span class="tt-eta__sep"> </span><span class="tt-eta__o">' + (sub.getAttribute('data-order') || '').replace('TIME', dur(r.until - t)) + '</span>';
    }
    if (sub.__tte !== html) { sub.__tte = html; sub.innerHTML = html; }
  }
  /* cart drawer / cart page line: «Lieferung in ca. 4 Wochen» with a custom tattoo, else the dates. The element is
     re-rendered by the theme on every cart change (data-has-custom from Liquid = the state of that render); between two
     renders our own cart state decides (sync after every change). */
  function renderCart(r) {
    var els = document.querySelectorAll('[data-tt-eta-cart]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], txt = el.querySelector('.cart-delivery-estimate__text');
      var hc = el.getAttribute('data-has-custom');
      var custom = hc === '1' || (hc == null && hasCustom);
      var mode = custom ? 'custom' : C.off ? 'off' : 'dates';
      if (txt && el.getAttribute('data-mode') !== mode) {
        el.setAttribute('data-mode', mode);
        if (mode === 'custom') txt.textContent = el.getAttribute('data-custom-text') || T.cline || '';
        else if (mode === 'dates' && el.getAttribute('data-dates-html')) txt.innerHTML = el.getAttribute('data-dates-html');
      }
      var f = el.querySelector('[data-delivery-from]'), to = el.querySelector('[data-delivery-to]');
      if (f && r) f.textContent = fmtDay(r.from);
      if (to && r) to.textContent = fmtDay(r.to);
      el.hidden = mode === 'off';
    }
  }
  function render() { var t = now(), r = calc(t); if (!C.off) renderPdp(r, t); renderCart(r); }
  /* for the shipping sheet (pdp-tattup.js): dates, dispatch day and cutoff of the visitor's country */
  function info() {
    var t = now(), r = calc(t);
    return { on: !C.off, cc: C.cc, lang: C.lang, min: +C.min, max: +C.max, cut: C.cut || '12:00', shipToday: r.ship === Math.floor(Date.UTC.apply(null, (function (p) { return [p.y, p.m - 1, p.d]; })(parts(t))) / DAY),
      from: shortDate(r.from, true), to: shortDate(r.to, true), ship: shortDate(r.ship, true), left: dur(r.until - t), cline: T.cline || '' };
  }

  /* ---------- checkout: refresh the properties first, then continue ---------- */
  function beforeCheckout() {
    clearTimeout(timer);
    return Promise.race([sync(), new Promise(function (res) { setTimeout(res, 4000); })]);
  }
  var going = false;
  var CHECKOUT = 'a[href*="/checkout"], [name="checkout"]';
  function go(el, form) {
    going = true;
    if (el) el.setAttribute('aria-busy', 'true');
    beforeCheckout().then(function () {
      if (el && el.tagName === 'A') { location.href = el.href; return; }
      var f = form || (el && (el.form || el.closest('form')));
      if (!f) { location.href = ROOT + 'checkout'; return; }
      if (el && el.name && !f.querySelector('input[type=hidden][name="' + el.name + '"]')) {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = el.name; h.value = el.value || ''; f.appendChild(h);
      }
      HTMLFormElement.prototype.submit.call(f);
    });
  }
  /* bubble phase on window: runs after the reward guard and the terms checkbox, which may stop or cancel the click */
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || going || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = e.target.closest && e.target.closest(CHECKOUT);
    if (!el || (el.tagName === 'A' && el.target === '_blank')) return;
    e.preventDefault();
    go(el);
  });
  window.addEventListener('submit', function (e) {
    if (e.defaultPrevented || going) return;
    var s = e.submitter, f = e.target;
    if (!(s && s.name === 'checkout') && !/\/checkout/.test(f.getAttribute('action') || '')) return;
    e.preventDefault();
    go(s, f);
  });

  /* ---------- triggers ---------- */
  document.addEventListener('on:cart:change', function () { if (!self) schedule(); render(); });
  document.addEventListener('on:cart:after-merge', render);
  document.addEventListener('on:cart-drawer:before-open', function () { render(); schedule(50); });
  document.addEventListener('dispatch:cart-drawer:open', function () { schedule(50); });
  /* back from the checkout (back/forward cache): a sync frozen mid-request never settles – start a fresh one */
  window.addEventListener('pageshow', function (e) { going = false; if (e.persisted) { running = null; again = false; render(); sync(); } });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    render();
    if (value() !== lastVal) sync();
  });
  setInterval(function () { if (document.visibilityState === 'visible' && document.querySelector('[data-tt-eta]')) render(); }, 20000);

  /* page view: write only if the printed cart differs from the rules */
  var seed = (C.cart || []).map(function (l) { return { key: l[0], requires_shipping: l[2] === 1, properties: l[3] }; });
  if (plan(seed)) sync();
  function ready() { render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();

  window.TTEta = { calc: calc, value: value, now: now, sync: sync, beforeCheckout: beforeCheckout, render: render, info: info, hasCustom: function () { return hasCustom; } };
})();
